import apiClient from './api';

export const perfilService = {
  // Listar todos los perfiles con paginación
  getAllPerfiles: async (params = {}) => {
    const { page = 0, size = 5, sortBy, direction } = params;
    let url = `/perfiles?page=${page}&size=${size}`;
    
    if (sortBy && direction) {
      url += `&sortBy=${sortBy}&direction=${direction}`;
    }
    
    const response = await apiClient.get(url);
    return response.data;
  },

  // Listar todos los perfiles (sin paginación - método original)
  getAllPerfilesSinPaginacion: async () => {
    const response = await apiClient.get('/perfiles');
    return response.data;
  },

  // Obtener perfil por ID
  getPerfilById: async (id) => {
    const response = await apiClient.get(`/perfiles/${id}`);
    return response.data;
  },

  // Crear nuevo perfil
  createPerfil: async (perfilData) => {
    const response = await apiClient.post('/perfiles', perfilData);
    return response.data;
  },

  // Actualizar perfil
  updatePerfil: async (id, perfilData) => {
    const response = await apiClient.put(`/perfiles/${id}`, perfilData);
    return response.data;
  },

  // Eliminar perfil
  deletePerfil: async (id) => {
    const response = await apiClient.delete(`/perfiles/${id}`);
    return response.data;
  },
};

export default perfilService;
